
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notification",
      function () {
        return require("private-next-pages/notification/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notification"])
      });
    }
  